

















import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'

@Component
export default class ComponentImage extends Vue {
  @Prop({
    type: [Object, String, Array],
    default: () => {},
  })
  private image!: IImageVariants | string

  @Prop({ type: String, default: '' }) private alt!: string
  @Prop({ type: String, default: '' }) private title!: string
  @Prop({ type: Boolean, default: false }) private cover!: boolean
  @Prop({ type: Boolean, default: true }) private lazyload!: boolean
  @Prop({ type: String, default: 'low' }) private fetchpriority!: string
  @Prop({ type: Boolean, default: false }) private multiply!: boolean
  @Prop({ type: Boolean, default: false }) private absolute!: boolean
  @Prop({ type: [String, Number], default: '' }) private aspectRatio!:
    | string
    | number

  private $style!: IStyle

  get computedClassImage() {
    return {
      [this.$style.image]: true,
      [this.$style.cover]: this.cover,
      [this.$style.multiply]: this.multiply,
    }
  }

  get computedStyleImageWrapper() {
    return this.aspectRatio ? { aspectRatio: String(this.aspectRatio) } : {}
  }

  private get computedClassImageWrapper() {
    return {
      [this.$style.imageWrapper]: true,
      [this.$style.cover]: this.cover && !this.absolute,
      [this.$style.absolute]: this.absolute,
    }
  }

  private renderedImage = ''

  private imageRender(): string {
    if (typeof this.image === 'string') return this.image
    if (Array.isArray(this.image)) return this.image.join(', ')
    return Object.entries(this.image)
      .map(([key, val]) => `${val} ${key}`)
      .join(', ')
  }

  @Watch('image', { immediate: true })
  private onImageChange() {
    this.updateRenderedImages()
  }

  private updateRenderedImages() {
    this.renderedImage = this.imageRender()
  }
}
